import { useEffect, useState } from "react";
import * as client from "@infrastructure/ClientConsumer";
import { generatePath } from "react-router-dom";

export const useActiveGames = () => {
    const [isActive, setActive] = useState(false);

    useEffect(() => {
        client
            .getData(generatePath(routes.GET_ACTIVE_GAMES))
            .then((res) => setActive(res.data.activeGroups.length > 0));
    }, []);

    return isActive;
};

const routes = {
    GET_ACTIVE_GAMES: "/active-games",
};
